export default __webpack_public_path__ + "static/screeny-150-storm-6-ae01f27d3da0c72dacb96ef5967d9b71.jpg";